async function parsePriceParams(searchParams) {
    if (_.has(searchParams, 'price_min') && _.has(searchParams, 'price_max')) {
        this.store.commit('setPrice', [searchParams.price_min, searchParams.price_max]);
    }
}

async function generatePriceParams() {
    let response = {};

    if (this.price.length) {
        response.price_min = this.price[0];
        response.price_max = this.price[1];
    }

    return response;
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        parsePriceParams,
        generatePriceParams
    },
    computed: {
        ...mapState([
            'price',
        ])
    },
}
